// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure the popup is positioned absolutely or fixed */
.notification-popup {
  position: absolute;
  top:40px;
  right: -70px; /* Position below the bell icon */

  z-index: 1000; /* Ensure it appears above other elements */
  background-color: white;
  border: 1px solid #fffdfd;
 
  min-width: 300px;
}

.text-notification {
  color:rgb(255, 123, 0);
}`, "",{"version":3,"sources":["webpack://./src/components/Header/popupNotification.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY,EAAE,iCAAiC;;EAE/C,aAAa,EAAE,2CAA2C;EAC1D,uBAAuB;EACvB,yBAAyB;;EAEzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/* Ensure the popup is positioned absolutely or fixed */\n.notification-popup {\n  position: absolute;\n  top:40px;\n  right: -70px; /* Position below the bell icon */\n\n  z-index: 1000; /* Ensure it appears above other elements */\n  background-color: white;\n  border: 1px solid #fffdfd;\n \n  min-width: 300px;\n}\n\n.text-notification {\n  color:rgb(255, 123, 0);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
